<app-agent-breadcrumb [inIXBRL]="true"></app-agent-breadcrumb>

<div class="page-header home no-margin-left">
  <h1 class="page-title">Document Formatting</h1>
  <p class="page-text">Agentic process to format document</p>
</div>

<!-- <app-feedback [projectId]="trialBalanceReportId"></app-feedback> -->

<!-- <app-ixbrl-instructions></app-ixbrl-instructions> -->

<div class="page-header">
  <h2 class="page-title">Document Formatting</h2>
  <p class="page-text"></p>
</div>

<div class="upload-progress-container">
  <motif-progress-indicator orientation="horizontal">
    @for (step of steps; track $index) {
    <motif-stepper
      [title]="step.title"
      [status]="step.status"
      [disabled]="step.disabled"
      [ngClass]="{ 'is-zoomed': isZoomed }"
    ></motif-stepper>
    }
  </motif-progress-indicator>

  @if (currentStep === 1) {
  <!--  -->
  @if (!runDocFormattingLoading) {
  <!--  -->
  <app-custom-motif-uploader
    [file]="fileToFormat"
    [acceptDoc]="true"
    [acceptExcel]="true"
    (fileEmitter)="onFileToFormatSelected($event)"
    (fileHasError)="onFileToFormatHasError($event)"
  ></app-custom-motif-uploader>
  <!--  -->
  } @if (runDocFormattingLoading) {
  <div class="progressbar-container">
    <motif-progress-bar
      [circle]="true"
      [showLabel]="true"
      [customLabel]="true"
      [tabIndex]="0"
      aria-label="Loading."
      aria-live="polite"
    ></motif-progress-bar>
    <p progressbar-label>Formatting and generating document preview...</p>
    <!-- TODO: Must add the different messages when the polling changes -->

    <!-- <p class="cancel-run" [tabIndex]="0" (click)="cancelDocFormatting()">Cancel</p> -->
  </div>
  }

  <button
    motifButton
    color="primary"
    (click)="runDocumentFormatting()"
    [disabled]="
      !fileToFormat || fileToFormatHasError || runDocFormattingLoading
    "
    aria-label="Upload Documents to Format"
    aria-live="assertive"
  >
    Upload
  </button>
  <!--  -->
  }

  <!--  -->
  @if (currentStep === 2) {

  <div class="process-message-container">
    <motif-icon
      [iconFunction]="IconoirCheckCircle"
      size="20"
      class="success-check"
    ></motif-icon>
    <p class="step-duration-message">{{ docFormattingDuration }}</p>
  </div>

  <div class="file-info-container">
    <p>File: {{ fileToFormat?.name }}</p>
    <p>
      Uploaded on:
      {{ fileUploadedOn + "Z" | date : "MMM d, y h:mm a" }}
    </p>
  </div>

  <app-custom-motif-downloader
    [filename]="formattedFile.filename"
    [fileId]="formattedFile.id"
    [fileSize]="formattedFile.file_size"
  ></app-custom-motif-downloader>

  <button
    motifButton
    color="primary-alt"
    (click)="goToPreviousStep(true)"
    [ariaLabel]="'Go back to step' + (currentStep - 1)"
    aria-live="assertive"
  >
    Go back
  </button>
  }
</div>

<div class="bg-image">
  @if(currentStep === 2) { }

  <div class="buttons-container">
    <div class="left">
      <button
        motifButton
        color="primary-alt"
        (click)="backHome()"
        aria-label="Go to iXBRL home page"
        aria-live="polite"
      >
        iXBRL Home
      </button>
      <button
        motifButton
        color="primary-alt"
        (click)="scrollUp()"
        aria-label="Scroll back to the top of the page"
        aria-live="polite"
      >
        Back to top
      </button>
    </div>
  </div>

  <app-disclaimer></app-disclaimer>
</div>
